import { MultiTermFilter } from '@opendoor/tessellation';

import { GetMarkets } from '../../../graphql/athena/types/GetMarkets';
import useGetMarkets from '../../../graphql/queries/fence/useGetMarkets';

interface MarketProps {
  field: string;
  title?: string;
}

const MarketFilter = ({ field = 'market', title = 'Market' }: MarketProps) => {
  const {
    data: fenceData,
    error: fenceError,
    loading,
  } = useGetMarkets({
    variables: { tags: ['market'] },
  });

  let options: string[] = [];
  if (!loading) {
    options = ((fenceData as GetMarkets).fence.getRegionsFromTags?.regions || [])
      .slice()
      .sort((a, b) => (a['identifier'] > b['identifier'] ? 1 : -1))
      .map((market) => market.identifier.toUpperCase());
  }

  if (fenceError) {
    return <>Failed to get Markets</>;
  }

  return <MultiTermFilter title={title} field={field} options={options} />;
};

export default MarketFilter;
